import { ContractBranchState } from '../../states/ContractBranchState';
import { Action } from 'redux';
import * as CommonFunctions from '../Common/Functions';
import ContractBranchesCreateReducer from './Contract.Branches.Create.Reducer';
import ContractBranchesUpdateReducer from './Contract.Branches.Update.Reducer';
import ContractBranchesDeleteReducer from './Contract.Branches.Delete.Reducer';


export const CombinedContractBranchReducer = CommonFunctions.reduceReducers<ContractBranchState>(
    ContractBranchesCreateReducer,
    ContractBranchesUpdateReducer,
    ContractBranchesDeleteReducer
);
